import { useContext } from 'react';

import { VehicleProfilingContext } from './VehicleProfilingContext';

/**
 * @return {VehicleProfilingContext Data}
*/
export const useVehicleProfilingData = () => {
  const {
    vehicleProfilingState,
  } = useContext(VehicleProfilingContext);

  return vehicleProfilingState;
};

/**
 * @return {VehicleProfilingContext Actions}
*/
export const useVehicleProfilingActions = () => {
  const {
    vehicleProfilingActions,
  } = useContext(VehicleProfilingContext);

  return vehicleProfilingActions;
};

/**
 * @return {VehicleProfilingContext}
*/
export const useVehicleProfilingContext = () => {
  const {
    vehicleProfilingActions,
    vehicleProfilingState,
  } = useContext(VehicleProfilingContext);

  return {
    ...vehicleProfilingActions,
    ...vehicleProfilingState,
  };
};
